export const PDFFooter = async ({ pdf }) => {
  const totalPages = pdf.internal.getNumberOfPages()

  for (let i = 1; i <= totalPages; i++) {
    pdf.setPage(i) // Move to the correct page

    const pageHeight = pdf.internal.pageSize.getHeight()
    const pageWidth = pdf.internal.pageSize.getWidth()

    // Set font and size
    pdf.setFont('helvetica', 'normal')
    pdf.setFontSize(10)

    // Generate the page number text
    const pageText = `Page ${i} `

    // Measure text width for alignment
    const textWidth = pdf.getTextWidth(pageText)

    // Properly position the text at the bottom right
    pdf.text(pageText, pageWidth - textWidth - 10, pageHeight - 12, {
      align: 'right',
    })
  }
}
